module.exports = __webpack_public_path__ + "img/banner-chanp.bf617272.png";